export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/zero-cost-repair.b12e7705.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};